import React, { Fragment } from 'react';
import { FormattedNumber } from 'react-intl';
import Translate from '../../components/Translate';

export var TableRow = function TableRow(_ref) {
  var data = _ref.data;
  return React.createElement(
    'tr',
    null,
    React.createElement(
      'td',
      null,
      data.Id
    ),
    React.createElement(
      'td',
      null,
      data.Description
    ),
    React.createElement(
      'td',
      null,
      React.createElement(Translate, {
        defaultMessage: 'label.type.bonus.' + data.Type.toLowerCase(),
        id: 'label.type.bonus.' + data.Type.toLowerCase()
      })
    ),
    React.createElement(
      'td',
      null,
      React.createElement(FormattedNumber, {
        value: data.Amount,
        style: data.Type && data.Type.toLowerCase() == 'freespins' ? 'decimal' : 'currency',
        currency: data.Currency
      })
    ),
    React.createElement(
      'td',
      null,
      (100 - data.WageringRequirmentRemaining / data.WageringRequirment * 100 || 0).toFixed(2),
      '% / 100%'
    )
  );
};

export var TableMobileRow = function TableMobileRow(_ref2) {
  var data = _ref2.data;

  return React.createElement(
    Fragment,
    null,
    React.createElement(
      'tr',
      { className: 'history-highlight-item' },
      React.createElement(
        'th',
        null,
        '#'
      ),
      React.createElement(
        'td',
        null,
        data.Id
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_name',
          id: 'label.bonus_table_name'
        })
      ),
      React.createElement(
        'td',
        null,
        data.Description
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_type',
          id: 'label.bonus_table_type'
        })
      ),
      React.createElement(
        'td',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.type.bonus.' + data.Type.toLowerCase(),
          id: 'label.type.bonus.' + data.Type.toLowerCase()
        })
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_amount',
          id: 'label.bonus_table_amount'
        })
      ),
      React.createElement(
        'td',
        null,
        React.createElement(FormattedNumber, {
          value: data.Amount,
          style: data.Type && data.Type.toLowerCase() == 'freespins' ? 'decimal' : 'currency',
          currency: data.Currency
        })
      )
    ),
    React.createElement(
      'tr',
      null,
      React.createElement(
        'th',
        null,
        React.createElement(Translate, {
          defaultMessage: 'label.bonus_table_wagering',
          id: 'label.bonus_table_wagering'
        })
      ),
      React.createElement(
        'td',
        null,
        (100 - data.WageringRequirmentRemaining / data.WageringRequirment * 100 || 0).toFixed(2),
        '% / 100%'
      )
    )
  );
};

export var TableRowNoData = function TableRowNoData() {
  return React.createElement(
    'center',
    null,
    React.createElement(Translate, { defaultMessage: 'label.no_bonuses', id: 'label.no_bonuses' })
  );
};